import { render, staticRenderFns } from "./ContentDeleteModal.vue?vue&type=template&id=4b70898f"
import script from "./ContentDeleteModal.vue?vue&type=script&lang=js"
export * from "./ContentDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b70898f')) {
      api.createRecord('4b70898f', component.options)
    } else {
      api.reload('4b70898f', component.options)
    }
    module.hot.accept("./ContentDeleteModal.vue?vue&type=template&id=4b70898f", function () {
      api.rerender('4b70898f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/ContentDeleteModal.vue"
export default component.exports